// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2dq0S","title":"FrontImage_title__2N_o8"};